import { useCallback, useContext, useEffect } from 'react';

import { useLanguage } from 'assets/languages';
import Checkbox from 'components/checkbox';
import CampaignFormFieldGroup from '../../../../../../../campaignFormFieldGroup/campaignFormFieldGroup';
import PhotoModelFields from '../../../formFields/photoModelFields/photoModelFields';
import { CampaignFormContext } from 'pages/campaigns/campaignForm/campaignForm.context';
import { FashionCampaignFormStepTwoContext } from '../../../../fashionCampaignFormStepTwo.context';
import { useWatch } from 'react-hook-form';
import { GUIDELINE_RULE_DTO_ENUMS } from 'api/repositories/guidelineRules/guidelineRules.constants';

const PhotoGuidelineFieldGroup = () => {
  const language = useLanguage();
  const languageTexts = { ...language.pages.campaigns };
  const { brand, guidelineRuleFormMethods } = useContext(CampaignFormContext);
  const { needAdditionalPhotos, setNeedAdditionalPhotos, initPhotoFields } = useContext(
    FashionCampaignFormStepTwoContext,
  );

  const [photoModelFull, photoModelHalf, photoModelCloseup] = useWatch({
    control: guidelineRuleFormMethods?.control,
    name: [
      GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.PHOTO_MODEL_FULL,
      GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.PHOTO_MODEL_HALF,
      GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.PHOTO_MODEL_CLOSEUP,
    ],
  });

  const onClickNeedAdditionalPhotos = useCallback(() => {
    setNeedAdditionalPhotos((prevNeedAdditionalPhotos) => {
      if (prevNeedAdditionalPhotos) {
        // 이미지 관련 formField 초기화
        initPhotoFields();
      }

      return !prevNeedAdditionalPhotos;
    });
  }, []);

  // 이미지가 있는 경우 추가 사진이 필요함으로 설정
  useEffect(() => {
    if (photoModelFull?.length > 0 || photoModelHalf?.length > 0 || photoModelCloseup?.length > 0) {
      setNeedAdditionalPhotos(true);
    }
  }, [photoModelFull, photoModelHalf, photoModelCloseup]);

  return (
    <CampaignFormFieldGroup label={languageTexts.create_reels_form_additional_photos}>
      <CampaignFormFieldGroup.FormField
        label={`${brand.isWholesale ? 10 : 11}. ${languageTexts.create_reels_form_additional_photos_2}`}
      >
        <div className="flex flex-col gap-[12px]">
          <Checkbox
            text={languageTexts.create_reels_form_checkbox_no_additional_photos}
            checked={!needAdditionalPhotos}
            onClick={onClickNeedAdditionalPhotos}
          />
          <Checkbox
            text={
              <div className="whitespace-pre-wrap leading-5">
                {languageTexts.create_reels_form_checkbox_additional_photos}
              </div>
            }
            checked={needAdditionalPhotos}
            onClick={onClickNeedAdditionalPhotos}
          />
        </div>
      </CampaignFormFieldGroup.FormField>

      {needAdditionalPhotos && <PhotoModelFields />}
    </CampaignFormFieldGroup>
  );
};

export default PhotoGuidelineFieldGroup;
